import { normalize, schema } from 'normalizr';
import {
  ApprovalWithAssociatedEntity as ApprovalWithAssociatedEntityApi,
  HomeResponse as HomeResponseApi,
} from 'api/home';
import { Project } from 'api/project';
import { NormalizedData } from 'data/core';
import { Task } from 'data/tasks';
import { taskSchema } from 'data/tasks/schema';

export interface ApprovalWithAssociatedEntity
  extends Omit<ApprovalWithAssociatedEntityApi, 'associatedEntity'> {
  associatedEntity: number;
}

const homeSchema = new schema.Object({
  myTasks: [taskSchema],
});

export interface HomeItems {
  myTasks: number[];
  myCompanyTasks?: number[];
}

export interface HomeEntities {
  tasks: NormalizedData<Task>;
  projects: NormalizedData<Pick<Project, 'projectId' | 'projectName'>>;
}

export const homeNormalizer = (data: HomeResponseApi) => {
  return normalize<HomeItems, HomeEntities, HomeItems>(data, homeSchema);
};
